import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PageHeading from './PageHeading';

function TermsPage() {
  return (
    <Container className="Center-column legal-page">
      <div className="pg-break"> </div>
      <PageHeading icon="document">Terms of Service</PageHeading>
      <div className="legal-content">
        <p className="legal-updated">Last updated: September 19, 2026</p>

        <h2>Agreement</h2>
        <p>
          Welcome to Nature&apos;s Nefer. By accessing our website or
          purchasing our products, you agree to these Terms of Service. If you
          do not agree, please do not use the site.
        </p>

        <h2>Products &amp; Orders</h2>
        <p>
          We strive to describe products accurately, including ingredients and
          intended use. Colors and appearance may vary slightly from photos.
          Placing an order is an offer to buy; we reserve the right to refuse
          or cancel orders due to stock, pricing errors, or suspected fraud.
        </p>

        <h2>Pricing &amp; Payment</h2>
        <p>
          Prices are listed in the currency shown at checkout and may change
          without notice. Payment is due at the time of purchase and is
          processed through our third-party payment provider.
        </p>

        <h2>Shipping</h2>
        <p>
          Delivery estimates are approximate. Risk of loss passes to you once
          the order is delivered to the address you provide. Please ensure
          shipping details are correct before completing checkout.
        </p>

        <h2>Accounts</h2>
        <p>
          You are responsible for keeping your login credentials secure and
          for activity under your account. Notify us promptly if you suspect
          unauthorized use.
        </p>

        <h2>Intellectual Property</h2>
        <p>
          All content on this site—including branding, text, images, and
          product names—belongs to Nature&apos;s Nefer or its licensors. You
          may not copy, distribute, or use our content for commercial purposes
          without written permission.
        </p>

        <h2>Product Use</h2>
        <p>
          Our products are for personal care as described. Discontinue use if
          irritation occurs. We are not liable for misuse or for results that
          vary by individual skin, hair, or lifestyle factors.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Nature&apos;s Nefer is not
          liable for indirect, incidental, or consequential damages arising
          from your use of the site or products. Our total liability for any
          claim related to a purchase will not exceed the amount you paid for
          that order.
        </p>

        <h2>Returns</h2>
        <p>
          Returns and refunds are governed by our{' '}
          <Link to="/refund">Refund Policy</Link>.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these terms at any time. Continued use of the site
          after changes means you accept the revised terms.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms can be sent through the support options
          on our website.
        </p>
      </div>
    </Container>
  );
}

export default TermsPage;
